module.exports = __webpack_public_path__ + "static/media/gn.1ce64523.svg";